import { Seo } from '../components/Seo';
import { LEGAL_PAGES } from '../lib/config';
import { Link } from 'react-router-dom';

const page = LEGAL_PAGES.find((p) => p.path === '/404')!;

export function NotFoundPage() {
  return (
    <>
      <Seo page={page} />
      <section className="mx-auto max-w-2xl px-4 py-20 text-center sm:px-6 lg:px-8">
        <h1 className="text-6xl font-extrabold text-text-muted">404</h1>
        <h2 className="mt-4 text-2xl font-bold text-text-primary">Page Not Found</h2>
        <p className="mt-3 text-lg text-text-secondary">
          The page you were looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          className="mt-8 inline-block rounded-full bg-primary px-8 py-3 font-semibold text-white hover:bg-primary-hover"
        >
          Back to Home
        </Link>
      </section>
    </>
  );
}
